export default "__VITE_ASSET__33d4fb25__"